module.exports = __webpack_public_path__ + "static/media/bg_sparring_woph-b.125df9a0.jpg";